const ComplementoEnajenaciondeAccionesRules = {
  ContratoIntermediacion: [
      'required',
      'string',
      'min:1',
      'max:300',
  ],
  Ganancia: [
      'required',
      'decimal:6',
  ],
  Perdida: [
      'required',
      'decimal:6',
  ]
};

export default ComplementoEnajenaciondeAccionesRules;